import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=46a202ac&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCollapseTransition: require('/app/components/base/CollapseTransition.vue').default,BaseIcon: require('/app/components/base/Icon.vue').default})
